import { render, staticRenderFns } from "./ReservationInStore.vue?vue&type=template&id=37914dd8&"
import script from "./ReservationInStore.vue?vue&type=script&lang=js&"
export * from "./ReservationInStore.vue?vue&type=script&lang=js&"
import style0 from "./ReservationInStore.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports